var React = require('react');

function Offline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-1-1h16v16H-1z","key":0}),React.createElement("path",{"fill":"#717274","d":"M9.236 1.43a6 6 0 0 0-7.805 7.807","key":1}),React.createElement("path",{"stroke":"#717274","strokeLinecap":"square","strokeWidth":"2","d":"M12 2L2 12","key":2}),React.createElement("path",{"fill":"#717274","d":"M4.76 12.567a6 6 0 0 0 7.805-7.807","key":3})]));
}

Offline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Offline;

Offline.default = Offline;
